'use client';

import { createContext, useContext } from 'react';

const InlineEditContext = createContext(null);

export function InlineEditProvider({ value, children }) {
    return (
        <InlineEditContext.Provider value={value}>
            {children}
        </InlineEditContext.Provider>
    );
}

export function useInlineEdit() {
    return useContext(InlineEditContext);
}
